import { addition, subtract } from './math';

export const withRunningStock = (rows = []) => {
  const stockByArticle = new Map();

  return rows.map((row) => {
    if (row.runningStock !== undefined && row.runningStock !== null) {
      stockByArticle.set(row.article_id, Number(row.runningStock));
      return row;
    }

    const currentStock = stockByArticle.get(row.article_id) || 0;
    const stockAfterEntry = addition(currentStock, row.entryStock);
    const runningStock = subtract(stockAfterEntry, row.outputStock);

    stockByArticle.set(row.article_id, runningStock);

    return {
      ...row,
      runningStock,
    };
  });
};
